export { DetailsReservationWidget } from './DetailsReservationWidget';
